import { useEffect } from 'react';

import { useSessionActions } from '../../store/session/actions';

export const SignOut = () => {
  const { signOut } = useSessionActions();

  useEffect(() => {
    signOut();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return null;
};
